import { combineReducers, Reducer, AnyAction } from '@reduxjs/toolkit';

import reducerGetEmployeesList from './reducers/employeesList';
import reducerGetFiredEmployeesList from './reducers/firedEmployees';
import reducerProfileEmployees from './reducers/profileEmployee';

interface EmployeesReducers {
	employeesList: Reducer<any, AnyAction>;
	firedEmployeesList: Reducer<any, AnyAction>;
	profileEmployees: Reducer<any, AnyAction>;
}

const RecruitingStore = combineReducers<EmployeesReducers>({
	employeesList: reducerGetEmployeesList,
	firedEmployeesList: reducerGetFiredEmployeesList,
	profileEmployees: reducerProfileEmployees,
});

export default RecruitingStore;
